import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getIssuedPolicySlice = createSlice({
  name: "getIssuedPolicy",
  initialState,
  reducers: {
    getIssuedPolicyStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getIssuedPolicySuccess(state, action) {
      state.loading = false;
      // const flattenedArray = []?.concat(...action?.payload);
      state.data = action?.payload;
      state.message = action.payload.message;
    },
    getIssuedPolicyFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getIssuedPolicyStart,
  getIssuedPolicySuccess,
  getIssuedPolicyFailure,
  clearError,
  clearMessage,
} = getIssuedPolicySlice.actions;

export default getIssuedPolicySlice.reducer;
